import { APP_VERSION, GIT_COMMIT_SHA_SHORT } from '@/constants/env';

export const version = APP_VERSION;

export const fullVersion = `${version}+${GIT_COMMIT_SHA_SHORT}`;

if (typeof window !== 'undefined') {
  window.__version__ = fullVersion;
}
